module.exports = __webpack_public_path__ + "media/EnergiaEolica.946db50f.mp4";